import { render, staticRenderFns } from "./PeriodAndFrequencySelect.vue?vue&type=template&id=6bac480f&lang=pug"
import script from "./PeriodAndFrequencySelect.vue?vue&type=script&lang=js"
export * from "./PeriodAndFrequencySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports